export const ASYNC_FLOW_CANCELLED = '__ASYNC_FLOW_CANCELLED__';

export const isAsyncFlowCancelled = (error: unknown): boolean =>
  error === ASYNC_FLOW_CANCELLED;
